
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns33c0b0478d4acbc65cecf852c4ad99cden from './en.yaml'
            i18n.addResourceBundle('en', '33c0b0478d4acbc65cecf852c4ad99cd', flattenObject(ns33c0b0478d4acbc65cecf852c4ad99cden), true, true);
        
        export default '33c0b0478d4acbc65cecf852c4ad99cd';
    